import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const AuthorContainer = styled(motion.div)`
  background-color: #1A1A1A;
  border-radius: 12px;
  padding: 24px;
  text-align: center;
  border: 1px solid #333;
  transition: all 0.3s ease;
  
  &:hover {
    border-color: #2196F3;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(33, 150, 243, 0.1);
  }
`;

const AuthorLink = styled.a`
  text-decoration: none;
  color: inherit;
  display: block;
`;

const AuthorImage = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin: 0 auto 16px;
  display: block;
  border: 3px solid #2196F3;
  object-fit: cover;
`;

const AuthorName = styled.h4`
  font-size: 18px;
  font-weight: 600;
  color: #FFFFFF;
  margin-bottom: 4px;
`;

const AuthorTitle = styled.p`
  font-size: 14px;
  color: #2196F3;
  margin-bottom: 8px;
  font-weight: 500;
`;

const AuthorDescription = styled.p`
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.4;
`;

const DMText = styled.p`
  font-size: 14px;
  color: #2196F3;
  font-weight: 600;
  margin-top: 8px;
  margin-bottom: 0;
`;

const AuthorSection = ({ 
  showDescription = true, 
  className = "",
  size = "normal",
  showDMText = false 
}) => {
  const isCompact = size === "compact";
  
  return (
    <AuthorContainer
      className={className}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      style={isCompact ? { padding: '16px' } : {}}
    >
      <AuthorLink 
        href="https://www.linkedin.com/in/nick-grigora/" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        <AuthorImage 
          src="/nick_logo.jpg" 
          alt="Nick Grigory"
          style={isCompact ? { width: '50px', height: '50px', marginBottom: '12px' } : {}}
        />
        <AuthorName style={isCompact ? { fontSize: '16px' } : {}}>
          Nick Grigory
        </AuthorName>
        <AuthorTitle style={isCompact ? { fontSize: '13px' } : {}}>
          Founder & CEO
        </AuthorTitle>
        {showDescription && (
          <AuthorDescription style={isCompact ? { fontSize: '12px' } : {}}>
            Passionate about revolutionizing the car buying experience through AI and transparency
          </AuthorDescription>
        )}
        {showDMText && (
          <DMText style={isCompact ? { fontSize: '13px' } : {}}>
            Got Any Questions? DM me
          </DMText>
        )}
      </AuthorLink>
    </AuthorContainer>
  );
};

export default AuthorSection;